/**
 * The debounce time in milliseconds for input events.
 * This constant is used to limit the rate at which input events are processed.
 * Should be used on any function which is called in response to an input event.
 */
export const DEBOUNCE_INPUT_TIME_MS = 250;
